/* src/app/components/shared/menu/menu.component.scss */
.category_menu {
  max-width: 201px !important;
}
/*# sourceMappingURL=menu.component.css.map */
